import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { AdministrableEmployerViewModel, EmployerViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { trackException } from '@fora-monorepo/webapp-analytics';

import { envConfig } from '../../config';
import { createThunkError } from '../utils';
import { mockAdministrableEmployers, mockEmployer } from './mocks';

export const getEmployer = createAsyncThunk('getEmployer', async (_, thunkAPI) => {
  if (envConfig.mockDataFrontend) {
    await new Promise(resolve => setTimeout(resolve, 500));
    return mockEmployer;
  }

  return axios
    .get(`${envConfig.bffBaseUri}/employer`)
    .then(res => {
      if (res.status === 200) {
        return res.data as EmployerViewModel;
      }
    })
    .catch(err => {
      trackException(err);
      return thunkAPI.rejectWithValue(createThunkError('Could not get employer', err));
    });
});

export const getAdministrableEmployers = createAsyncThunk(
  'getEmployers',
  async (role: string | undefined, thunkAPI) => {
    if (envConfig.mockDataFrontend) {
      await new Promise(resolve => setTimeout(resolve, 500));
      return mockAdministrableEmployers;
    }

    return axios
      .get(`${envConfig.bffBaseUri}/employers`)
      .then(res => {
        if (res.status === 200) {
          return res.data as AdministrableEmployerViewModel[];
        }
      })
      .catch(err => {
        trackException(err);
        return thunkAPI.rejectWithValue(createThunkError('Could not get employer', err));
      });
  }
);
